import { useMemo } from "react";

import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResourceOperation } from "types/generated";

import useCellCopyAction from "../useCellCopyAction";

const IntentProjectOperationsTableOperationCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<IntentResourceOperation>) => {
  const value = item.operation.toUpperCase();
  const copyAction = useCellCopyAction({
    text: value,
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellText>{value}</TableCellText>
    </TableSimpleCell>
  );
};

export default IntentProjectOperationsTableOperationCell;
